import SWRPG from './swrpg';

export default SWRPG;
export { SWRPG };